import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import React from 'react';
import sidebarLogo from '../../assets/sidebarLogo.png';
import { MainMenuStyle } from './MainMenuStyle';

interface ListOptionsProp {
  readonly daily: boolean;
  readonly label: boolean;
  readonly influx: boolean;
  readonly executive: boolean;
  readonly weekly: boolean;
  readonly monthly: boolean;
  readonly plugin: boolean;
  readonly history: boolean;
  readonly action: boolean;
  readonly impact: boolean;
}

const ListOptions = () => {
  const classes = MainMenuStyle();
  
  return (
    <>
      <List>
        <ListItem className={classes.listLogo}>
          <img className={classes.drawerImg} src={sidebarLogo} alt="sidebar" />
        </ListItem>
      </List>
    </>
  );
};

export default ListOptions;
